export default __webpack_public_path__ + "static/media/mcd_en.9c792507.png";